export const partnerId = "hivits";

// hivits: legacy | integrated
export const niceAuthMode: "legacy" | "integrated" = "integrated";
